export default `
fragment ParagraphVideoNetshow on ParagraphVideoNetshow {
  id
  uuid
  entityBundle
  title
  netshow_url
}
`
